import React from 'react';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';
import { policyTypes } from '@ourbranch/policy-types';

import { ExpandableCard } from 'core/components/expandable-card';
import { useStore } from 'core/store/store.mobx';
import { useDiscounts } from 'offer/hooks/use-discounts';
import { MultilineDiscount } from './multiline-discount';
import { Discount } from './discount';
import { Paperless } from './paperless';
import { Inventory } from './inventory';
import { BranchPlusMultiPolicyDiscount } from './branch-plus-multi-policy-discount';
import { ConnectedHomeDiscount } from './connected-home-discount';
import { BundleDiscount } from './bundle-discount';
import { GoodStudent } from './good-student';
import { DrivingCourse } from './driving-course';
import { CommunityDrive } from './community-drive';

const DiscountToComponent = {
  paperless_savings: Paperless,
  imagery_collection_savings: Inventory,
  connected_home_discount_savings: ConnectedHomeDiscount,
  multi_policy_savings: BranchPlusMultiPolicyDiscount,
  bundle_savings: BundleDiscount,
  good_student: GoodStudent,
  driving_course: DrivingCourse,
  community_drive: CommunityDrive
};

const DiscountsCard = observer(() => {
  const discounts = useDiscounts();
  const activeDiscounts = discounts.filter(({ isActive }) => isActive).length;
  const { offer: store } = useStore();
  const { values } = useFormikContext();
  const selectedOption = values?.selectedOption || store.selectedOption;
  const bundleCurrentlySelected = [policyTypes.ARBundle, policyTypes.HABundle, policyTypes.CABundle].includes(
    selectedOption
  );

  const showMultilineDiscountComponent = store.hardRejectionOnOffer && !bundleCurrentlySelected;

  return (
    <ExpandableCard title="Discounts" badge={`${activeDiscounts} of ${discounts.length}`}>
      {discounts.map(({ canEdit, label, isActive, amount, description, possibleSavings, appcuesId, id }, ix) => {
        const Component = DiscountToComponent[id] || Discount;
        return (
          <Component
            key={ix}
            label={label}
            amount={amount}
            possibleSavings={possibleSavings}
            description={description}
            isActive={isActive}
            appcuesId={appcuesId}
            canEdit={canEdit}
            id={id}
          />
        );
      })}
      {showMultilineDiscountComponent && <MultilineDiscount />}
    </ExpandableCard>
  );
});

export default DiscountsCard;
